import * as axios from '../../axios-extended'
import { Query } from './types'
import * as t from 'io-ts'
import { Item } from '../../types'

const apiUrl = '/prosperbill/api'

const Items = t.type({
  data: t.array(Item),
  count: t.number,
})

export const getItems = (
  organization: string,
  {
    page = 0,
    itemsPerPage = 10,
    sort = ['id', 'desc'],
    name = undefined,
  }: Partial<Query>,
  signal?: AbortSignal
) =>
  axios.get(`${apiUrl}/items/${organization}`, {
    signal,
    params: {
      name,
      page,
      size: itemsPerPage,
      sort: `${sort[0]},${sort[1]}`,
    },
    decoder: Items,
  })

export const addItem = (
  organization: string,
  { name, description, price }: Omit<Item, 'id'>,
  cancelToken?: axios.CancelToken
) =>
  axios.post(
    `${apiUrl}/items/${organization}`,
    { name, description, price },
    { cancelToken, decoder: t.unknown }
  )

export const editItem = (
  organization: string,
  i: Item,
  cancelToken?: axios.CancelToken
) =>
  axios.put(`${apiUrl}/items/${organization}`, i, {
    cancelToken,
    decoder: Item,
  })

export const deleteItem = (
  organization: string,
  id: number,
  cancelToken?: axios.CancelToken
) =>
  axios.delete_(`${apiUrl}/items/${organization}/${id}`, {
    cancelToken,
    decoder: t.unknown,
  })
